import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import ImageComponent from '../ImageComponent/ImageComponent';

import styles from './ContactComponent.module.scss';

const PUBLIC_ID_FIELD = 'publicID';
function ContactComponent(props) {
    const { id, config } = props;
    const [aSummary, setSummary] = useState({});
    const { authHeader } = useAuthentication();
    const {
        displayName, userType, city, phoneNumber, email, image
    } = aSummary;

    const { ContactService } = useDependencies('ContactService');

    const renderCityAndPhoneNumberSection = useCallback(() => {
        const dataFormat = city && phoneNumber ? `${city}, ${phoneNumber}` : city || phoneNumber;
        return <div>{dataFormat}</div>;
    }, [city, phoneNumber]);

    const mailToTrigger = useCallback((event) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, [email]);

    useEffect(() => {
        const fetchData = async () => {
            if (_.isFunction(ContactService.getContactSummaries)) {
                const summaries = await ContactService.getContactSummaries(authHeader);
                const allSummariesAreEqual = summaries.every((summary) => {
                    return summary[PUBLIC_ID_FIELD] === summaries[0][PUBLIC_ID_FIELD];
                });
                if (summaries.length > 1 && !allSummariesAreEqual) {
                    return [];
                }
                const mergeData = _.merge(summaries[0], config);
                if (!config.image) {
                    const imageName = mergeData.publicID.replace(':', '-'); // to avoid image file names with ":"
                    mergeData.image = `/contact/${imageName}.png`;
                }
                return setSummary(mergeData);
            }
            return setSummary(config);
        };
        fetchData();
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!image) {
        return null;
    }

    return (
        <div className={styles.gwContactModule} id={id}>
            <div className={styles.gwContactInformationContainer}>
                {displayName && <div className={styles.gwDisplayName}>{displayName}</div>}
                {userType && <div>{userType}</div>}
                {renderCityAndPhoneNumberSection()}
                {email && (
                    <div>
                        <Link href="/" onClick={mailToTrigger} className={styles.gwEmail}>
                            {email}
                        </Link>
                    </div>
                )}
            </div>
            <div className={styles.gwImageContainer}>
                <ImageComponent src={image} alt="contactImage" />
            </div>
        </div>
    );
}

ContactComponent.propTypes = {
    id: PropTypes.string,
    config: PropTypes.shape({
        displayName: PropTypes.string,
        userType: PropTypes.string,
        city: PropTypes.string,
        phoneNumber: PropTypes.string,
        email: PropTypes.string,
        image: PropTypes.string.isRequired
    })
};

ContactComponent.defaultProps = {
    id: undefined,
    config: PropTypes.shape({
        displayName: undefined,
        userType: undefined,
        city: undefined,
        phoneNumber: undefined,
        email: undefined
    })
};

export default ContactComponent;
